import * as service from './service'
export default {
  namespace: 'ShCommitment',
  state: {
    agreeData: {}
  },
  effects: {

    * agree ({ payload }, { call, put }) {
      const res = yield call(service.agree, payload)
      yield put({
        type: 'save',
        payload: {
          agreeData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
